module.exports = __webpack_public_path__ + "img/orders-pagination-next.d7760ba8.svg";